import CategoryForm from "../../../../component/CategoryForm/CategoryForm";
import TreeSelect from "../../../../component/TreeSelect/TreeSelect";
import {listToTree} from "../../../../assets/functions";
import AreaBlockTreeSelect from "../../../Towns/component/AreaBlockTreeSelect/AreaBlockTreeSelect";
import {getUnionAreaObject} from "../../../Towns/functions";
import TextInput, {TextInputWithoutContainer} from "../../../../component/TextInput/TextInput";
import {SelectWithoutContainer} from "../../../../component/Select/Select";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import {Fragment, useEffect, useState} from "react";
import {getAllProductCategoriesObject} from "../../functions";
import Loading from "../../../../component/Loading/Loading";
import {getAllDriversObject} from "../../../Drivers/functions";
import {getAllPeopleDividedByRole} from "../../../../component/PersonForm/functions";

const CreditCardForm = ({creditCard, onChange}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [allPeopleDividedByRole, setAllPeopleDividedByRole] = useState(true);

    useEffect(() => {
        (async () => {
            setAllPeopleDividedByRole(await getAllPeopleDividedByRole());
            setIsLoading(false);
        })();

    }, []);

    const changeCreditCard = (key , value) => {
        const newCreditCard = {...creditCard , [key] : value};
        onChange(newCreditCard);
    }


    if (isLoading)
        return <Loading/>

    return (
        <div className={"row"}>
            <div className="col-md-6">
                <TextInput maxlen={16} classname={"ltr"} label={"شماره کارت"} value={creditCard.number} onChange={(value) => {
                    changeCreditCard("number", value);
                }}/>
            </div>

            <div className="col-md-6">
                <TextInput maxlen={24} classname={"ltr"} label={"شبا (بدون IR)"} value={creditCard.shaba} onChange={(value) => {
                    changeCreditCard("shaba", value);
                }}/>
            </div>
            <div className="col-md-6">
                <TextInput label={"نام و نام خانوادگی"} value={creditCard.name} onChange={(value) => {
                    changeCreditCard("name", value);
                }}/>
            </div>
            <div className="col-md-6">
                <TextInput label={"بانک"} value={creditCard.bank} onChange={(value) => {
                    changeCreditCard("bank", value);
                }}/>
            </div>
            <div className="col-12">
                <TreeSelect mode={"radioSelect"} label={"صاحب حساب"} data={listToTree(allPeopleDividedByRole , [creditCard.personId])} onChange={(value) => {
                    const newPersonId = value.length == 1 && !isNaN(value[0]) ? value[0] : "" ;
                    changeCreditCard("personId", newPersonId);
                }} />
            </div>
        </div>
    );
}

export default CreditCardForm;